import { render, staticRenderFns } from "./BackButton.vue?vue&type=template&id=3dfcc895&scoped=true&"
var script = {}
import style0 from "./BackButton.vue?vue&type=style&index=0&id=3dfcc895&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dfcc895",
  null
  
)

export default component.exports